import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { ResponseMessageStatus, ResponseStatus } from 'src/app/shared/enums';
import { BadeLoftService } from '../bade-loft.service';
declare const bindScript: any;
@Component({
  selector: 'app-core',
  templateUrl: './core.component.html',
  styleUrls: ['./core.component.css'],
})
export class CoreComponent implements OnInit {
  //#region properties
  userInfoObj: any;
  currentUrl: string;
  incompleteStatusCount: any = 0;
  //#endregion

  //#region functions
  logOut() {
    this._cS.logOut();
    document.title = 'Login - Badeloft';
    this._router.navigate(['/login']);
  }
  //#endregion

  constructor(
    private _router: Router,
    public _cS: CommonService,
    private _blS: BadeLoftService
  ) {
    this.currentUrl = this._router.url;
    _router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }

  getIncompletedStatusCount() {
    try {
      this._blS.getIncompletedStatusCount().subscribe((response: any) => {
        this.incompleteStatusCount = response;
      });
    } catch (error) {}
  }

  ngOnInit(): void {
    bindScript();
    this.userInfoObj = this._cS.getUserObj();
    this.userInfoObj = JSON.parse(this.userInfoObj);
    // this.getIncompletedStatusCount();

    this._cS.incompleteStatusCountObserver.subscribe((res: any) => {
      this.getIncompletedStatusCount();
    });
  }
  navigateToStatus() {
    this._router.navigate(['/bade-loft/status']);
    // , {
    //   queryParams: { filterstatus: 2 },
    // }
    this._cS.incompleteStatusRecords.next('call');
  }
}
